import { render, staticRenderFns } from "./BannerAreaComponent.vue?vue&type=template&id=5b4a5aee&lang=pug&"
import script from "./BannerAreaComponent.vue?vue&type=script&lang=js&"
export * from "./BannerAreaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports